import { render, staticRenderFns } from "./vuecomm97n0.vue?vue&type=template&id=310863c8&scoped=true"
import script from "./vuecomm97n0.vue?vue&type=script&lang=js"
export * from "./vuecomm97n0.vue?vue&type=script&lang=js"
import style0 from "./vuecomm97n0.vue?vue&type=style&index=0&id=310863c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310863c8",
  null
  
)

export default component.exports